import $ from 'jquery';

$(function () {
  const searchReset = $('.js-searchReset');
  const searchInput = $('.js-searchForm input');
  searchInput.on('focus', function () {
    $(this).parent('.js-searchForm').addClass('is-focused');
    $(this).next(searchReset).toggle();
    $('.p-header__navbar').addClass('is-search-active');
  });

  searchInput.on('blur', function () {
    searchEnactivate();
  });

  searchReset.on('click', function () {
    searchEnactivate();
  });

  $(window).on('resize', function () {
    searchEnactivate();
  });

  const searchEnactivate = () => {
    searchInput.val('');
    searchReset.hide();
    $('.js-searchForm').removeClass('is-focused');
    $('.p-header__navbar').removeClass('is-search-active');
  };
});
